export default __webpack_public_path__ + "static/media/fureverhomes3.d677146a.png";